import axios from 'axios';
import { getField, updateField } from 'vuex-map-fields';

export default {
  namespaced: true,
  state: {
    dailyEmails: [],
    weeklyEmails: [],
    monthlyEmails: [],
    annuallyEmails: [],
  },

  mutations: {
    updateField,
    SET_EMAILS(state, payload) {
      state.dailyEmails = payload.daily;
      state.weeklyEmails = payload.weekly;
      state.monthlyEmails = payload.monthly;
      state.annuallyEmails = payload.annually;
    },

    SET_DAILY(state, payload) {
      state.dailyEmails.push(payload[0]);
    },

    SET_WEEKLY(state, payload) {
      state.weeklyEmails.push(payload[0]);
    },

    SET_MONTHLY(state, payload) {
      state.monthlyEmails.push(payload[0]);
    },

    SET_ANNUALLY(state, payload) {
      state.annuallyEmails.push(payload[0]);
    },
  },

  actions: {
    async getEmails({ commit }, obj) {
      try {
        const { data } = await axios.get(
          `${process.env.API_ROOT}/bulletin/${obj.companyId}`,
          {
            headers: { 'x-access-token': obj.token },
          },
        );

        commit('SET_EMAILS', data);
      } catch (error) {
        window.console.log(error);
      }
    },

    async storeBulletin({ commit }, obj) {
      try {
        await axios.post(
          `${process.env.API_ROOT}/bulletin/${obj.companyId}`,
          { ...obj.data },
          { headers: { 'x-access-token': obj.token } },
        );

        commit(`SET_${obj.data.type.toUpperCase()}`, obj.data.emails);
      } catch (error) {
        window.console.log(error);
      }
    },

    async deleteEmail({ commit }, obj) {
      try {
        const { data } = await axios.delete(
          `${process.env.API_ROOT}/bulletin/${obj.companyId}`,
          {
            headers: { 'x-access-token': obj.token },
            data: { ...obj.data },
          },
        );

        commit('SET_EMAILS', data);
      } catch (error) {
        window.console.log(error);
      }
    },
  },

  getters: { getField },
};



// WEBPACK FOOTER //
// ./src/store/modules/bulletins/index.js